module.exports = __webpack_public_path__ + "img/auth-page-splash.86b267c6.jpg";